<template lang="pug">
.supercharged-entertainment-container
  .page-reload-play-card.book-race
    .book-form
      form(@submit.prevent="addToCartAndGo")

        agree-to-terms.book-form__agreement(v-model="termsAgreed")

        re-group-box.book-form__tab.playcard-number-and-cvv(:class="{ disabled: !termsAreAgreed }")
          template(slot="title") {{PLAYCARD_TC}} Number
          span.book-form__tab__number 1
          p.info-note Specify the {{PLAYCARD_TC}} Number you would like to reload.
          .selector.flex-rows
            .flex-grow.playcard-number(:class="{ 'p-r-15' : !isOwner }")
              label {{PLAYCARD_TC}} Number
              input.m-b-5(v-model="playcardNumber" type="number" @input="$v.playcardNumber.$reset" :class="{ 'book-form__input-full' : !isOwner }" :readonly="isOwner")
              a.big-on-dark(href="" @click.prevent="$refs.whatIsNumberModal.show") What is this?
            .flex-grow.p-l-15.playcard-cvv(v-if="!isOwner")
              label CVV
              input.book-form__input-full.m-b-5(v-model="playcardCvv" type="password" placeholder="****" maxlength="4" @input="$v.playcardCvv.$reset")
              a.big-on-dark(href="" @click.prevent="$refs.whatIsCvvModal.show") What is this?

        re-group-box.book-form__tab.playcard-amount(:class="{ disabled: !termsAreAgreed || $v.playcardNumber.$error || (!isOwner && $v.playcardCvv.$error) }")
          template(slot="title") Select your amount
          span.book-form__tab__number 2
          p.info-note Select an Amount &amp; Reload {{PLAYCARD_TC}}.
          .selector.flex-rows
            .flex-grow.p-r-15.playcard-product
              label Amount
              select(v-model="playcardProductId" @input="$v.playcardProductId.$reset")
                option(v-for="{ id, title } in playcardProducts" :value="id") {{ title }}
            .flex-grow.p-l-15.playcard-quantity
              label Quantity
              input.book-form__input-full(v-model="playcardQuantity" type="number" min="1" step="1" @input="$v.playcardQuantity.$reset")

          template(v-if="playcardProduct")
            template(v-for="upgrade in playcardProduct.upgrades")
              .card-detail
                .card-detail-name {{ upgrade.title }}
                .card-detail-input
                  .rides-input-box
                    button.text-button.text-button--minus(
                      :class="{ disabled: (upgrades[upgrade.name] || 0) < 1 }"
                      @click.prevent="$set(upgrades, upgrade.name, (upgrades[upgrade.name] || 0) - 1)"
                    ) –
                    .racer-quantity-value {{ upgrades[upgrade.name] || 0 }}
                    button.text-button(
                      :class="{disabled: upgrade.max_count != null && upgrade.max_count != '' && upgrades[upgrade.name] >= upgrade.max_count }"
                      @click.prevent="$set(upgrades, upgrade.name, (upgrades[upgrade.name] || 0) + 1)"
                    ) +
                p.info-note The cost of {{ upgrade.title }} is {{ upgrade.price | currency }}.

        re-content-placeholder(name="card_reload_below_product_selection")
        bonus-box.m-t-30(v-if="playcardProduct && playcardQuantity" :bonus="playcardProduct.balance.bonus_cash * playcardQuantity")

        re-toast-alert.m-t-40(v-if="checkingErrorMessage" type="danger") {{ checkingErrorMessage }}

        would-you-like-to.m-t-30(v-if="!editMode" exclude="supercharged.reload-play-card" @before-route="likeClick")

        .book-form__add-to-cart
          v-button.site_button.site_button_inverse(:disabled="!termsAreAgreed || addingToCartDisabled" :loading="isChecking || isAddingToCart")
            span {{ editMode ? 'Update Cart' : 'Add to Cart' }}

  what-is-modal(ref="whatIsNumberModal" :img-src="`${config.baseUri}/images/supercharged/playcard-number-example.png`")
  what-is-modal(ref="whatIsCvvModal" :img-src="`${config.baseUri}/images/supercharged/playcard-cvv-example.png`")

</template>

<script>
import PagesMixin from '../../components/_mixins/pages'
import ConfigMixin from '../../components/_mixins/config'
import AgreeToTerms from '../../components/parts/AgreeToTerms'
import LocationMixin from 'utils/vue/mixins/location'
import BonusBox from '../../components/parts/BonusBox'
import { required, integer } from 'vuelidate/lib/validators'
import { getFirstErrorMessage } from '~/lib/axios'
import WouldYouLikeTo from '../../components/parts/would-you-like-to'
import {getQS} from '../../lib/utils'
const qs = getQS() || {}

const mixins = [
  ConfigMixin,
  PagesMixin,
  LocationMixin
]

try {
  mixins.push(require('marketing/playcards/_mixins/reload-playcard-form').default)
} catch (e) {}

export default {
  name: 'page-reload-play-card',
  settings: 'page.reload-card',
  translations: 'page.reload-card',
  components: {
    AgreeToTerms,
    BonusBox,
    WouldYouLikeTo,
  },

  mixins,

  data: () => ({
    termsAgreed: 'no',
    playcardCvv: null,
    isChecking: false,
    checkingErrorMessage: null,
    isOwner: false,
    upgrades: {},
  }),

  validations: {
    playcardCvv: {
      required,
      integer,
    },
  },

  created() {
    if (qs.item || this.$route.query.item) {
      this.setEditItem(qs.item || this.$route.query.item)
      if (this.editItem) {
        this.upgrades = _.cloneDeep(this.editItem.payload.options.upgrades)
      }
    }

    if (qs.owner || this.$route.query.owner) {
      this.isOwner = true
    }

    if (!this.editMode) {
      this.playcardQuantity = 1
      this.playcardNumber = qs.number || this.$route.query.number
    } else {
      this.termsAgreed = 'yes'
    }

    this.$v.$touch()
  },

  watch: {
    playcardProductId(newVal) {
      EventBus.$emit('card.reload.productId', newVal)
      EventBus.$emit('card.reload.product', this.playcardProduct)
      EventBus.$emit('card.reload.select-product-with-location', {
        product: this.playcardProduct,
        location_id: this.currentLocationId
      })
    }
  },
  computed: {
    termsAreAgreed() {
      return this.termsAgreed == 'yes'
    },

    addingToCartDisabled() {
      return this.$v.playcardProductId.$error || this.$v.playcardNumber.$error || (!this.isOwner && this.$v.playcardCvv.$error) || this.$v.playcardQuantity.$invalid
    },
  },

  methods: {
    async addToCartAndGo() {
      if (await this.addToCart()) {
        this.$router.push({ name: 'racewaybooking.checkout' })
      }
    },

    async addToCart() {
      try {
        this.isChecking = true

        if (this.isOwner) {
          const where = {
            number: this.playcardNumber.replace(/^0+/, '')
          }
          const { data: { data: playcards } } = await axios.get(`${this.config.apiUri}/customer/playcard?where=${JSON.stringify(where)}`)

          if (!playcards.length) {
            throw 'This {{PLAYCARD}} doesn\'t belong to your account'
          }
        } else {
          const payload = {
            number: this.playcardNumber,
            cvv: this.playcardCvv,
          }
          await axios.post(`${this.config.apiUri}/customer/playcard/details`, payload)
        }

        this.checkingErrorMessage = null

        const item = this.getPlaycardCartItem()

        _.set(item, 'payload.options.upgrades', this.upgrades)

        if (this.currentLocationId) {
          _.set(item, 'payload.options.location_id', this.currentLocationId)
        }
        await this.addPlaycardCartItem(item)
        this.$router.push({ name: 'racewaybooking.checkout' })

        return true
      } catch (e) {
        this.checkingErrorMessage = typeof(e) === 'string' ? e : getFirstErrorMessage(e)
      } finally {
        this.isChecking = false
      }
    },

    async likeClick() {
      if (this.termsAreAgreed && !this.addingToCartDisabled && !this.editMode) {
        await this.addToCart()
      }
    },
  }
}
</script>

<style lang="scss">
@import '../../components/_scss/base';

.supercharged-entertainment-container .page-reload-play-card {
  .radio-container {
    margin-bottom: unset;
  }

  .book-form {
    padding-bottom: 85px;
  }

  .book-form__tab.playcard-amount .selector .flex-grow {
    flex-basis: 0;
  }

  @media screen and (max-width: 770px) {
    .book-form__tab {
      &.playcard-number-and-cvv,
      &.playcard-amount {
        .selector {
          flex-direction: column;
          .flex-grow {
            padding: 0;
          }
        }
      }
      &.playcard-number-and-cvv .selector .playcard-cvv {
        margin-top: 10px;
      }
      &.playcard-amount .selector .playcard-product {
        margin-bottom: 15px;
      }
    }
    .book-form__tab__radio label {
      padding-bottom: 24px;
    }
  }
}
</style>
